import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import "./AddAccount.css";

const AddAccount = ({ addUser }) => {
  // state for toggling the form
  const [showForm, setShowForm] = useState(false);

  // state for the new user form
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    verifyPassword: "",
    admin: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.verifyPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const res = await fetch("https://security-backend-1nbc.onrender.com/api/addAccount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.error) {
        alert("Failed to add user: " + data.error);
        return;
      }

      // add user to parent state
      addUser({
        id: data.id, // backend ID
        name: form.name,
        email: form.email,
        created_at: new Date(),
        admin: form.admin,
      });

      // reset form and close it
      setForm({
        name: "",
        email: "",
        password: "",
        verifyPassword: "",
        admin: false,
      });
      setShowForm(false);
    } catch (err) {
      console.error("Failed to add user:", err);
    }
  };

  return (
    <div className="add-account-container">
      <button
        className="add-account-btn"
        onClick={() => setShowForm(!showForm)}
      >
        <FaPlus /> Add Account
      </button>

      {showForm && (
        <form className="add-account-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="verifyPassword"
            placeholder="Verify Password"
            value={form.verifyPassword}
            onChange={handleChange}
            required
          />
          <label className="admin-checkbox">
            <input
              type="checkbox"
              name="admin"
              checked={form.admin}
              onChange={handleChange}
            />
            Admin
          </label>
          <button type="submit" className="add-account-save-btn">
            Save
          </button>
        </form>
      )}
    </div>
  );
};

export default AddAccount;
